export enum MemberDetailTabValue {
  GENERAL = 'general',
  CLOSET = 'closet',
  CONNECT = 'connect',
}

export const getMemberDetailTabList = (userId: string) => [
  {
    label: 'GENERAL',
    value: MemberDetailTabValue.GENERAL,
    to: `/member/${userId}/${MemberDetailTabValue.GENERAL}`,
  },
  {
    label: 'CLO-SET',
    value: MemberDetailTabValue.CLOSET,
    to: `/member/${userId}/${MemberDetailTabValue.CLOSET}`,
  },
  {
    label: 'CONNECT',
    value: MemberDetailTabValue.CONNECT,
    to: `/member/${userId}/${MemberDetailTabValue.CONNECT}`,
  },
];

export const getMemberDetailTabValue = (pathname: string) => {
  if (pathname.includes(MemberDetailTabValue.CLOSET)) {
    return MemberDetailTabValue.CLOSET;
  }
  if (pathname.includes(MemberDetailTabValue.CONNECT)) {
    return MemberDetailTabValue.CONNECT;
  }
  return MemberDetailTabValue.GENERAL;
};
